/* Bisou 2.0 — Free gift with every order.
   Keeps exactly one gift line (the hidden 0 kr gift product, property _free_gift) in the cart
   whenever the campaign is active and the cart contains anything else above the minimum.
   Removes it when the cart is otherwise empty — or when the campaign has ended (end date in
   Theme settings → Free gift campaign), so no 0 kr gift lingers in old carts. */
(function () {
  var cfg = window.BisouFreeGift;
  if (!cfg || !cfg.variantId) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var queued = false;
  var ownRequest = false;

  function isGift(item) {
    if (item.variant_id === cfg.variantId || (cfg.productId && item.product_id === cfg.productId)) return true;
    return !!(item.properties && (item.properties._free_gift === 'true' || item.properties._free_gift === true));
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  function render(sections) {
    var d = drawer();
    if (d && sections && typeof d.renderContent === 'function') d.renderContent(sections);
  }

  function request(path, body) {
    ownRequest = true;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: ['cart-drawer'], sections_url: window.location.pathname }, body))
    }).then(function (r) { return r.json(); }).finally(function () { ownRequest = false; });
  }

  function check() {
    if (busy) { queued = true; return; }
    busy = true;
    ownRequest = true;
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ownRequest = false;
        var others = [], gifts = [], subtotal = 0;
        (cart.items || []).forEach(function (it) {
          if (isGift(it)) gifts.push(it); else { others.push(it); subtotal += it.final_line_price; }
        });
        var want = !!cfg.enabled && others.length > 0 && subtotal >= (cfg.minCents || 0);

        if (want && gifts.length === 0) {
          return request('cart/add.js', { items: [{ id: cfg.variantId, quantity: 1, properties: { _free_gift: 'true' } }] })
            .then(function (res) { if (res && res.sections) render(res.sections); });
        }
        if (!want && gifts.length > 0) {
          return request('cart/change.js', { id: gifts[0].key, quantity: 0 })
            .then(function (res) { if (res && res.sections) render(res.sections); if (gifts.length > 1) queued = true; });
        }
        if (want && gifts.length > 0 && (gifts[0].quantity !== 1 || gifts.length > 1)) {
          var extra = gifts.length > 1 ? gifts[1] : gifts[0];
          var qty = gifts.length > 1 ? 0 : 1;
          return request('cart/change.js', { id: extra.key, quantity: qty })
            .then(function (res) { if (res && res.sections) render(res.sections); if (gifts.length > 2) queued = true; });
        }
      })
      .catch(function (e) { console.warn('[free-gift]', e); })
      .finally(function () {
        busy = false; ownRequest = false;
        if (queued) { queued = false; check(); }
      });
  }

  /* Watch every cart mutation the theme makes */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (!ownRequest && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(check, 50); }, function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
})();
